import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { getRemainingTime } from 'helpers/ContentHelper';
import Style from './Timer.module.scss';

const TimeEntry = React.memo(({ title = '', value = 0 }) => (
  <div className={Style.timeEntry}>
    <div className={Style.timeValue}>{`${value < 10 ? '0' : ''}${value < 0 ? 0 : value}`}</div>
    <div className={Style.timeTitle}>{title}</div>
  </div>
));

const Timer = ({
  countdownTime = '',
  hideTimerWhenActive = true,
  isActive = false,
  isMidBanner = false,
  mobileKicker = false,
  setIsActive = () => {},
  setIsSameDay = () => {},
}) => {
  const initTimeRemaining = getRemainingTime(countdownTime);
  const [days, setDays] = useState(initTimeRemaining?.days);
  const [hours, setHours] = useState(initTimeRemaining?.hours);
  const [minutes, setMinutes] = useState(initTimeRemaining?.minutes);
  const [seconds, setSeconds] = useState(initTimeRemaining?.seconds);
  const [counter, setCounter] = useState(initTimeRemaining?.total);

  useEffect(() => {
    let intervalId;
    if (days === 0) setIsSameDay(true);
    if (counter > -1) {
      intervalId = setInterval(() => {
        const timeRemaining = getRemainingTime(countdownTime);
        setDays(timeRemaining?.days);
        setHours(timeRemaining?.hours);
        setMinutes(timeRemaining?.minutes);
        setSeconds(timeRemaining?.seconds);
        setCounter(timeRemaining?.total);
      }, 1000);
    } else {
      setIsActive(true);
    }
    return () => clearInterval(intervalId);
  }, [countdownTime, counter, days, setIsActive, setIsSameDay]);
  if (hideTimerWhenActive && isActive) return null;
  const timerClassNames = classNames([
    Style.timer,
    isMidBanner ? Style.isMidBanner : mobileKicker && Style.desktopOnly,
  ]);
  return (
    <>
      <div className={timerClassNames}>
        <div className={Style.timerContainer}>
          {!!days && <TimeEntry title="Days" value={days} />}
          <TimeEntry title="Hours" value={hours} />
          <TimeEntry title="Minutes" value={minutes} />
          {!days && <TimeEntry title="Seconds" value={seconds} />}
        </div>
      </div>
      {mobileKicker && (
        <div className={classNames(Style.mobileKickerTimer, Style.mobileOnly)}>
          <div className={Style.timerContainer}>
            <TimeEntry title="Days" value={days} /> :
            <TimeEntry title="Hours" value={hours} /> :
            <TimeEntry title="Minutes" value={minutes} />
            <TimeEntry title="Seconds" value={seconds} />
          </div>
        </div>
      )}
    </>
  );
};

TimeEntry.propTypes = {
  title: PropTypes.string,
  value: PropTypes.number,
};

Timer.propTypes = {
  countdownTime: PropTypes.string,
  hideTimerWhenActive: PropTypes.bool,
  isActive: PropTypes.bool,
  isMidBanner: PropTypes.bool,
  mobileKicker: PropTypes.bool,
  setIsActive: PropTypes.func,
  setIsSameDay: PropTypes.func,
};

export default Timer;
